import mobileTenantConfig from './MobileTenantConfig';

const { tenantId } = mobileTenantConfig;

export default tenantId;
